import { h } from './element';
import { bindClickoutside, unbindClickoutside } from './event';
import { cssPrefix } from '../config';
import Icon from './icon';
import FormInput from './form_input';
import Dropdown from './dropdown';
import { xtoast } from './message';
import { tf,t } from '../locale/locale';

class DropdownMore extends Dropdown {
  constructor(click) {
    const icon = new Icon('ellipsis');
    super(icon, 'auto', false, 'top-left');
    this.contentClick = click;
  }

  reset(items) {
    const eles = items.map((it, i) => h('div', `${cssPrefix}-item`)
      .css('width', '150px')
      .css('font-weight', 'normal')
      .on('click', () => {
        this.contentClick(i);
        this.hide();
      })
      .child(it));
    this.setContentChildren(...eles);
  }

  setTitle() {}
}

const menuItems = [
  { key: 'delete', title: tf('contextmenu.deleteSheet') },
];

function buildMenuItem(item) {
  return h('div', `${cssPrefix}-item`)
    .child(item.title())
    .on('click', () => {
      this.itemClick(item.key);
      this.hide();
    });
}

function buildMenu() {
  return menuItems.map(it => buildMenuItem.call(this, it));
}

class ContextMenu {
  constructor(showAddSheet) {
    if (showAddSheet) {
      this.el = h('div', `${cssPrefix}-contextmenu`)
			.css('width', '160px')
			//代码库修改，屏蔽删除按钮
      .children(...buildMenu.call(this))
      .hide();
    } else {
      this.el = h('div', `${cssPrefix}-contextmenu`)
			.css('width', '160px')
      .hide();
    }
    this.itemClick = () => {};
  }

  hide() {
    const { el } = this;
    el.hide();
    unbindClickoutside(el);
  }

  setOffset(offset) {
    const { el } = this;
    el.offset(offset);
    el.show();
    bindClickoutside(el);
  }
}

export default class Bottombar {
  constructor(switchFunc = () => {},
    addFunc = () => {},
    swapFunc = () => {},
    deleteFunc = () => {},
    updateFunc = () => {},
    errorAlertFunc = () => {},showAddSheet=false,canEditSheetName=false) {
    this.transitionTime = 500;
    this.dragging = null;
    this.cloned = null;
    this.overNode = null;

    this.showAddSheet = showAddSheet;
    this.canEditSheetName = canEditSheetName;
    this.switchFunc = switchFunc;
    this.swapFunc = swapFunc;
    this.updateFunc = updateFunc;
    this.errorAlertFunc = errorAlertFunc;
    this.dataNames = [];
    this.activeEl = null;
    this.deleteEl = null;
    this.items = [];
    this.itemsInputOpenStatus = [];//各个sheet输入开启状态
    this.moreEl = new DropdownMore((i) => {
      this.clickSwap2(this.items[i]);
    });
    this.contextMenu = new ContextMenu(showAddSheet);
    this.dropItemsDiv = h('div', `${cssPrefix}-menu-droppable`)

    //代码库修改，屏蔽加号
    if (this.showAddSheet) {
      this.contextMenu.itemClick = deleteFunc;
      this.el = h('div', `${cssPrefix}-bottombar`).children(
        this.contextMenu.el,
        this.menuEl = h('ul', `${cssPrefix}-menu`).children(
          h('li', '').children(
            new Icon('add').on('click', () => {
              if (this.dataNames.length < 10) {
                addFunc();
              } else {
                errorAlertFunc(t('bottombar.lessThan10Sheet'));
                // xtoast('tip', 'it less than or equal to 10');
              }
            }),
            h('span', '').child(this.moreEl),
          ),
          this.dropItemsDiv,
        ),
      );     
    }else
    {
      this.el = h('div', `${cssPrefix}-bottombar`).children(
        this.contextMenu.el,
        this.menuEl = h('ul', `${cssPrefix}-menu`).children(
          h('li', '').children(
            h('span', '').child(this.moreEl),
          ),
          this.dropItemsDiv,
        ),
      );
    }

    // drag start
    document.removeEventListener('dragstart', this.dragstart.bind(this));
    document.addEventListener('dragstart', this.dragstart.bind(this));
    // drag over
    document.removeEventListener('dragover', this.dragover.bind(this));
    document.addEventListener('dragover', this.dragover.bind(this));

    // drag end
    document.removeEventListener('dragend', this.dragend.bind(this));
    document.addEventListener('dragend', this.dragend.bind(this));
  }

  dragstart(e){
    if (e.target.classList.contains('draggable')) {
      console.log("dragstart.......",e.target.innerText);
      this.dragging = e.target;
      this.dragging.classList.add('dragging');
      // this.cloned = this.dragging.cloneNode(true);
    }
  }
  dragover(e){
    e.preventDefault();
    if (e.target.classList.contains('draggable')) {
      console.log("dragover1.......",e.target.innerText);
      this.overNode = e.target;
    }
  }
  dragend(e){
    console.log("dragend.......",e.target);
    if (this.overNode) {
      // this.cloned.classList.add('new-added');
      
      this.handleDragEnd(this.overNode, this.dragging);
    }
  }

  cleanClass(className) {
    const elements = document.querySelectorAll(`.${className}`);
    for (const el of elements) {
      el.classList.remove(className);
    }
  }

  handleDragEnd(overNode, draggNode) {
    if (overNode && draggNode) {
      let overName = overNode.innerText;
      let draggName = draggNode.innerText;
      let overIndex = this.items.findIndex(item=>item.el.innerText==overName);
      let dragIndex = this.items.findIndex(item=>item.el.innerText==draggName);
      // console.log("this.items start......", JSON.parse(JSON.stringify(this.items)));
      if (overIndex>=0 && dragIndex>=0) {
        console.log("overIndex overName......", overIndex, overName);
        console.log("dragIndex draggName......", dragIndex, draggName);
        if (dragIndex<overIndex) {//往后拖动
          this.overNode.insertAdjacentElement('afterend', this.dragging);
          this.items.splice(overIndex, 0, this.items.splice(dragIndex,1)[0]);
          this.dataNames.splice(overIndex, 0, this.dataNames.splice(dragIndex,1)[0]);
          this.switchFunc(overIndex,dragIndex);
        }else if (dragIndex>overIndex){//往前拖动
          this.overNode.insertAdjacentElement('beforebegin', this.dragging);
          this.items.splice(overIndex, 0, this.items.splice(dragIndex,1)[0]);
          this.dataNames.splice(overIndex, 0, this.dataNames.splice(dragIndex,1)[0]);
          this.switchFunc(overIndex,dragIndex);
        }
        this.moreEl.reset(this.dataNames);
      }
    }
    
  
    // if (!this.dragging) return;
    // this.dragging.classList.add('will-remove');
    // setTimeout(() => {
    //   this.dragging.remove();
    //   this.cleanClass('dragging');
    // }, [this.transitionTime]);
  }

  addItem(name, active) {
    this.dataNames.push(name);
    this.itemsInputOpenStatus.push(false);
    let item = null;

    const editImg = h('span', `el-icon-edit activeColor sheet-name-edit-span`).on('click', () => {
      let isTouchClear = false;
      const v = item.text();

      const nindex = this.dataNames.findIndex(it => it === v);
      this.itemsInputOpenStatus.splice(nindex,1,true);
      //屏蔽sheet点击修改
      
      console.log("item......", item);
      console.log("item.text()......", item.text());
      const input = new FormInput('auto', '');
      input.val(v);
      input.input.on('input', ({ target }) => {
        const { value } = target;
        if (value) {
          input.input.attr('style','border: 1px solid #e9e9e9;color:rgb(0,0,0);');
        }
      }).on('blur', ({ target }) => {
        if (!isTouchClear) {
          const { value } = target;
          const nindex = this.dataNames.findIndex(it => it === v);
          this.renameItem(nindex, value,input.input);
        }
        /*
        this.dataNames.splice(nindex, 1, value);
        this.moreEl.reset(this.dataNames);
        item.html('').child(value);
        this.updateFunc(nindex, value);
        */
      }).attr('maxlength',31);
      // item.html('').child(input.el);
      item.html('').children(input.el,h('span', `el-icon-circle-close sheet-name-clear-span`).on('click',()=>{
        input.val('');
        input.focus();
      }).on('mouseover', ({ target }) => {
        isTouchClear = true
      }).on('mouseout', ({ target }) => {
        isTouchClear = false
      }));
      input.focus();
    })
    
    if (this.canEditSheetName) {
      item = h('li', active ? 'active draggable' : 'draggable').children(name,editImg).attr('draggable',true);
    } else {
      item = h('li', active ? 'active draggable' : 'draggable').children(name).attr('draggable',true);
    }
    item.on('click', () => {
      const index = this.items.findIndex(it => it === item);
      console.log("item index......", index);
      if (!this.itemsInputOpenStatus[index]) {
        this.clickSwap2(item);
      }
    }).on('contextmenu', (evt) => {
      const { offsetLeft, offsetHeight } = evt.target;
      this.contextMenu.setOffset({ left: offsetLeft, bottom: offsetHeight + 1 });
      this.deleteEl = item;
    }).on('dblclick', () => {
      const index = this.items.findIndex(it => it === item);
      console.log("item index......", index);
      if (this.canEditSheetName && !this.itemsInputOpenStatus[index]) {
        let isTouchClear = false;

        //屏蔽sheet点击修改
        const v = item.text();

        const nindex = this.dataNames.findIndex(it => it === v);
        this.itemsInputOpenStatus.splice(nindex,1,true);

        const input = new FormInput('auto', '');
        input.val(v);
        input.input.on('input', ({ target }) => {
          const { value } = target;
          if (value) {
            input.input.attr('style','border: 1px solid #e9e9e9;color:rgb(0,0,0);');
          }
        }).on('blur', ({ target }) => {
          if (!isTouchClear) {
            const { value } = target;
            const nindex = this.dataNames.findIndex(it => it === v);
            this.renameItem(nindex, value,input.input);
          }
          /*
          this.dataNames.splice(nindex, 1, value);
          this.moreEl.reset(this.dataNames);
          item.html('').child(value);
          this.updateFunc(nindex, value);
          */
        }).attr('maxlength',31);
        // item.html('').child(input.el);
        item.html('').children(input.el,h('span', `el-icon-circle-close sheet-name-clear-span`).on('click',()=>{
          input.val('');
          input.focus();
        }).on('mouseover', ({ target }) => {
          isTouchClear = true
        }).on('mouseout', ({ target }) => {
          isTouchClear = false
        }));
        input.focus();
      } else {
        
      }
      
    });
    if (active) {
      this.clickSwap(item);
    }
    this.items.push(item);
    this.dropItemsDiv.child(item);
    this.moreEl.reset(this.dataNames);
  }

  renameItem(index, value, input) {
    if (value=='' || !value) {
      input.attr('style','border: 1px solid red;').attr('placeholder',t('bottombar.inputNamePlease'));
      // this.dataNames.splice(index, 1, value);
      // this.moreEl.reset(this.dataNames);
      this.updateFunc(index, value);
      // this.itemsInputOpenStatus.splice(index,1,false);
      return;
    }else{
      //判断不能重复
      let cacheNames = [...this.dataNames];
      cacheNames.splice(index, 1);
      if (cacheNames.some(name=>name==value)) {
        input.attr('style','border: 1px solid red;');
        this.updateFunc(index, value);
        console.log("t('bottombar.nameSameAlert')......",t('bottombar.nameSameAlert'));
        this.errorAlertFunc(t('bottombar.nameSameAlert'));
        return;
      } else {
        input.attr('style','border: 1px solid #e9e9e9;color:rgb(0,0,0);');
        this.dataNames.splice(index, 1, value);
      }
    }
    
    this.moreEl.reset(this.dataNames);
    // this.items[index].html('').child(value);
    this.items[index].html('').children(value,h('span', `el-icon-edit activeColor sheet-name-edit-span`).on('click', ({ target }) => {
      console.log("target......", target);
      //屏蔽sheet点击修改
      const v = target.parentNode.innerText;
      const sindex = this.dataNames.findIndex(it => it === v);

      this.itemsInputOpenStatus.splice(sindex,1,true);

      let isTouchClear = false;
      const input = new FormInput('auto', '');
      input.val(v);
      input.input.on('input', ({ target }) => {
        const { value } = target;
        if (value) {
          input.input.attr('style','border: 1px solid #e9e9e9;color:rgb(0,0,0);');
        }
      }).on('blur', ({ target }) => {
        if (!isTouchClear) {
          const { value } = target;
          const nindex = this.dataNames.findIndex(it => it === v);
          this.renameItem(nindex, value,input.input);
        }
        
        /*
        this.dataNames.splice(nindex, 1, value);
        this.moreEl.reset(this.dataNames);
        item.html('').child(value);
        this.updateFunc(nindex, value);
        */
      }).attr('maxlength',31);
      // item.html('').child(input.el);
      this.items[sindex].html('').children(input.el,h('span', `el-icon-circle-close sheet-name-clear-span`).on('click',()=>{
        input.val('');
        input.focus();
      }).on('mouseover', ({ target }) => {
        isTouchClear = true
      }).on('mouseout', ({ target }) => {
        isTouchClear = false
      }));
      input.focus();
    }));
    this.updateFunc(index, value);
    this.itemsInputOpenStatus.splice(index,1,false);
  }

  clear() {
    this.items.forEach((it) => {
      this.dropItemsDiv.removeChild(it.el);
    });
    this.items = [];
    this.dataNames = [];
    this.moreEl.reset(this.dataNames);
  }

  clearEvents(){
    // drag start
    document.removeEventListener('dragstart', this.dragstart.bind(this));
    // drag over
    document.removeEventListener('dragover', this.dragover.bind(this));
    // drag end
    document.removeEventListener('dragend', this.dragend.bind(this));
  }

  deleteItem() {
    const { activeEl, deleteEl } = this;
    if (this.items.length > 1) {
      const index = this.items.findIndex(it => it === deleteEl);
      this.items.splice(index, 1);
      this.dataNames.splice(index, 1);
      this.dropItemsDiv.removeChild(deleteEl.el);
      this.moreEl.reset(this.dataNames);
      if (activeEl === deleteEl) {
        const [f] = this.items;
        this.activeEl = f;
        this.activeEl.toggle();
        return [index, 0];
      }
      return [index, -1];
    }
    return [-1];
  }

  getSheetIndex(){
    return this.items.findIndex(it => it.el.innerText === this.activeEl.el.innerText);
  }

  clickSwap2(item) {
    const index = this.items.findIndex(it => it === item);
    this.clickSwap(item);
    this.activeEl.toggle();
    this.swapFunc(index);
  }

  clickSwap(item) {
    if (this.activeEl !== null) {
      this.activeEl.toggle();
    }
    this.activeEl = item;
  }
}
